import React, {
  MouseEvent,
  useCallback,
} from 'react';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';
import Spinner from 'pages/Dashboard/components/Spinner';
import {
  useNotify,
} from 'core/hooks';
import {
  useSendPCCReminder,
} from 'views/EMR/hooks/pcc';

type Props = {
  patientId: number;
  disabled?: boolean;
  className?: string;
};

export default function SendPCCReminderButton({ patientId, disabled, className }: Props) {
  const notify = useNotify();
  const {
    mutateAsync: sendPCCReminder,
    isPending: isLoading,
  } = useSendPCCReminder();

  const handleClick = useCallback(async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      await sendPCCReminder({ patientId });
      notify({
        variant: 'success',
        message: 'PCC reminder sent.',
      });
    } catch {
      // Global mutation onError handles error notify
    }
  }, [notify, patientId, sendPCCReminder]);

  return (
    <Button
      className={clsx(
        '!py-0.5 !px-0 !min-w-[160px]',
        { '!border-blue-500': !isLoading },
        className,
      )}
      variant="outlined"
      type="button"
      color="primary"
      onClick={handleClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <div className="gap-2 flex items-center">
          <Spinner size={16} />
          Sending...
        </div>
      ) : 'Send PCC Reminder'}
    </Button>
  );
}
